"use client"

import { useRouter } from "next/navigation"
import { QueryClient } from "@tanstack/react-query"

import useGetAuthenticationCore, {
  type UseGetAuthenticationParams,
} from "./use-get-authentication-core"

export {
  getAuthentication,
  oauthAvatarUrlFromUser,
  type UseGetAuthenticationParams,
} from "./get-authentication"

/**
 * Next.js wrapper — delegates to `use-get-authentication-core` and injects
 * `router.replace` so the core stays free of `next/navigation`.
 * Web (Next.js) apps import this; mobile (Expo) apps use the core directly.
 */
export default function useGetAuthentication(
  params: UseGetAuthenticationParams = {},
  queryClient?: QueryClient,
) {
  const router = useRouter()
  return useGetAuthenticationCore(params, queryClient, router.replace.bind(router))
}
